import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=A%20warm%20and%20vibrant%20streaming%20studio%20interior%20with%20colorful%20ambient%20lighting%20featuring%20a%20modern%20gaming%20setup%20with%20multiple%20monitors%20displaying%20chat%20and%20gameplay%20soft%20bokeh%20effect%20with%20warm%20orange%20and%20golden%20tones%20cozy%20and%20energetic%20atmosphere%20cinematic%20composition&width=1920&height=1080&seq=hero-bg-main&orientation=landscape')`,
        }}
      >
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/20 text-background-50 text-xs font-medium mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            每日更新 · 精彩不断
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
            狗头萝莉视频
          </h1>
          <p className="text-sm md:text-lg text-background-50/80 max-w-xl mx-auto leading-relaxed mb-8">
            最新最全的狗头萝莉精彩视频合集 · 直播录屏 · 搞笑片段 · 日常Vlog · 粉丝互动
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/live-recordings"
              className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <span className="w-4 h-4 inline-flex items-center justify-center mr-2">
                <i className="ri-play-circle-line"></i>
              </span>
              立即观看
            </Link>
            <Link
              to="/about"
              className="w-full sm:w-auto px-8 py-3 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm text-background-50 font-medium text-sm rounded-full border border-background-50/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-10">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">500+</p>
              <p className="text-xs text-background-50/70 mt-1">精彩视频</p>
            </div>
            <div className="w-px h-8 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">200万+</p>
              <p className="text-xs text-background-50/70 mt-1">忠实粉丝</p>
            </div>
            <div className="w-px h-8 bg-background-50/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">6</p>
              <p className="text-xs text-background-50/70 mt-1">内容分类</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}